import {
  SET_USER_AUTH,
  SET_TOTAL_COVID19,
  SET_TOTAL_KUNJUNGAN,
  SET_TOTAL_OBAT_EXPIRED,
  SET_SELECTED_KARYAWAN,
} from "../types";

const INITIAL_STATE = {
  userAuth: [],
  user: {},
  totalCovid19: 0,
  totalKunjungan: 0,
  totalObatExpired: 0,
  karyawan: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USER_AUTH:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TOTAL_COVID19:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TOTAL_KUNJUNGAN:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TOTAL_OBAT_EXPIRED:
      return {
        ...state,
        ...action.payload,
      };
    case SET_SELECTED_KARYAWAN:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return INITIAL_STATE;
  }
};
